import React, { Component } from 'react';
import PageHeader from '../page-header/page-header.component.js';

class About extends Component {
	render() {
		const { label, title, description, image } = this.props.data;
		return (
			<section id="about">
				<div className="container container-fluid">
					<div className="row middle-xs">
						<div className="col-xs-12 col-md-6 col-lg-6 text">
							<PageHeader title={label} />
							<h2>{title}</h2>
							<p>{description}</p>
						</div>
						<div className="col-xs-12 col-md-5 col-lg-6 img">
							<div className="image">
								<img
									src={`${process.env.REACT_APP_API_ENDPOINT + image.path}`}
									alt={title}
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export default About;
